(function () {
  'use strict';

  const CODE = /^[ABCDEFGHJKMNPQRSTUVWXYZ23456789]{6}$/;
  const messages = Object.freeze({
    invalid_code: 'Nie rozpoznajemy tego kodu. Sprawdź go i spróbuj ponownie.',
    already_redeemed: 'Ten kod został już wykorzystany. Jeśli prezent został dodany do Twojego konta, zaloguj się, aby go sprawdzić.',
    expired: 'Termin odbioru tego prezentu minął.',
    purchase_data_mismatch: 'Nie możemy potwierdzić danych zakupu. Sprawdź wpisane dane lub skontaktuj się z nami.',
    verification_required: 'Nie możemy potwierdzić danych zakupu. Sprawdź wpisane dane lub skontaktuj się z nami.',
    rate_limited: 'Zbyt wiele prób. Spróbuj ponownie za kilka minut.',
    error: 'Nie udało się teraz odebrać prezentu. Spróbuj ponownie za chwilę.',
    processing_unknown: 'Sprawdzamy, czy prezent został dodany do konta. Nie musisz ponownie wysyłać formularza.',
    unavailable: 'Odbiór prezentu jest chwilowo niedostępny. Spróbuj ponownie później.',
    account_mismatch: 'Zgłoszenie jest zapisane. Konto Shopify ma inny adres e-mail niż formularz. Zmień konto i potwierdź ten sam e-mail. Nie musisz wypełniać formularza ponownie.',
    authentication_required: 'Zgłoszenie jest zapisane. Potwierdź swój e-mail w Shopify, aby dokończyć odbiór. Nie musisz wypełniać formularza ponownie.',
    claim_expired: 'Sesja odbioru wygasła. Wypełnij formularz ponownie, aby rozpocząć nową sesję.',
    identity_unavailable: 'Nie udało się teraz potwierdzić logowania. Twoje zgłoszenie jest zapisane. Spróbuj ponownie przyciskiem poniżej.',
    invalid_phone: 'Ten numer telefonu jest nieprawidłowy. Popraw go, aby dokończyć odbiór. Twoje zgłoszenie jest zapisane.',
    order_not_eligible: 'Nie możemy przyznać prezentu dla tego zamówienia (np. zostało zwrócone, anulowane albo minął termin odbioru). Napisz do nas: kontakt@tenbut.pl.',
    limit_reached: 'Na tym koncie prezent został już odebrany. Jeden prezent przysługuje na jedno konto.',
    terms_required: 'Zaakceptuj regulamin promocji, aby odebrać prezent.'
  });

  function normalizeCode(value) {
    return String(value || '').trim().toUpperCase();
  }

  function initialCode(search) {
    if (typeof search !== 'string' || search.length > 4096) return '';
    try {
      // URLSearchParams tolerates broken escapes; reject them before decoding.
      decodeURIComponent(search.replace(/\+/g, ' '));
      const values = new URLSearchParams(search).getAll('kod').map(normalizeCode);
      if (!values.length || new Set(values).size !== 1 || !CODE.test(values[0])) return '';
      return values[0];
    } catch (_) {
      return '';
    }
  }

  function normalizePhone(value) {
    let phone = String(value || '').trim().replace(/[\s()-]/g, '');
    if (phone.startsWith('0048')) phone = phone.slice(4);
    else if (phone.startsWith('+48')) phone = phone.slice(3);
    // Preview checks national number shape only, not allocation or ownership.
    return /^[1-9][0-9]{8}$/.test(phone) ? '+48' + phone : '';
  }

  function validate(values, emailValid) {
    const errors = {};
    if (!values.given_name.trim()) errors.given_name = 'Wpisz imię.';
    if (!normalizePhone(values.phone)) errors.phone = 'Wpisz poprawny polski numer telefonu: +48 i 9 cyfr.';
    if (!emailValid || !values.email.trim()) errors.email = 'Wpisz poprawny adres e-mail.';
    const code = normalizeCode(values.code);
    if (!CODE.test(code)) errors.code = code.length < 6
      ? 'Wpisz 6-znakowy kod z karty.' : messages.invalid_code;
    if (!values.terms) errors.terms = 'Zaakceptuj regulamin promocji, aby odebrać prezent.';
    return errors;
  }

  function confirmedPreview(result) {
    return result && result.state === 'success' && result.demo === true &&
      typeof result.operation === 'string' && result.operation.length > 0 &&
      typeof result.amount === 'number' && Number.isFinite(result.amount) &&
      result.amount > 0 && result.amount <= 1000000 && result.currency === 'PLN' &&
      result.accountPath === '/pages/moje-konto';
  }

  function confirmedDevelopment(result) {
    return result && result.state === 'success' && result.environment === 'development' &&
      /^[a-f0-9]{24}$/.test(result.operation || '') && result.amount === '50.00' &&
      result.currency === 'PLN' && result.accountPath === '/pages/moje-konto';
  }

  // Production receipt: same shape as the rehearsal, but only ever from the production service.
  function confirmedProduction(result) {
    return result && result.state === 'success' && result.environment === 'production' &&
      /^[a-f0-9]{24}$/.test(result.operation || '') && result.amount === '50.00' &&
      result.currency === 'PLN' && result.accountPath === '/pages/moje-konto';
  }

  if (typeof module !== 'undefined' && module.exports) {
    module.exports = { normalizeCode, initialCode, normalizePhone, validate, confirmedPreview, confirmedDevelopment, confirmedProduction };
  }
  if (typeof window === 'undefined' || !window.customElements || customElements.get('ten-but-prezent')) return;

  class TenButPrezent extends HTMLElement {
    connectedCallback() {
      if (this._initialized) return;
      this._initialized = true;
      this._busy = false;
      this._locked = false;
      this._captureOnly = this.hasAttribute('data-capture-only');
      this._form = this.querySelector('form');
      this._fields = this.querySelector('[data-fields]');
      this._button = this.querySelector('button[type="submit"]');
      this._label = this.querySelector('[data-button-label]');
      this._status = this.querySelector('[role="status"]');
      this._code = this._form.elements.code;
      this._code.value = initialCode(typeof window.__tbPrezentInitialSearch === 'string' ? window.__tbPrezentInitialSearch : window.location.search);
      delete window.__tbPrezentInitialSearch;
      this._form.addEventListener('submit', (event) => {
        event.preventDefault();
        this._submit();
      });
      this._form.addEventListener('input', (event) => {
        const name = event.target.name;
        if (!name) return;
        const error = this.querySelector('[data-error="' + name + '"]');
        if (error) error.textContent = '';
        event.target.removeAttribute('aria-invalid');
      });
      this._code.addEventListener('blur', () => { this._code.value = normalizeCode(this._code.value); });
      // Listener is installed before fields are enabled: no no-JS PII submission.
      this._fields.disabled = false;
    }

    enablePreview(transport) {
      // Demonstrations cannot be enabled by URL parameters or on the live store.
      if (!['127.0.0.1', 'localhost', '[::1]'].includes(window.location.hostname) || typeof transport !== 'function') return false;
      this._previewTransport = transport;
      if (!this._busy && !this._locked) this._button.disabled = false;
      this._status.textContent = '';
      return true;
    }

    enableCapture(transport) {
      if (!this._captureOnly || !['https://tenbut.pl', 'https://www.tenbut.pl'].includes(window.location.origin) || typeof transport !== 'function') return false;
      this._previewTransport = transport;
      this._button.disabled = false;
      return true;
    }

    // Production redemption on tenbut.pl only, never enabled by URL parameters.
    enableRedeem(transport) {
      if (!this.hasAttribute('data-redeem') || window.location.origin !== 'https://tenbut.pl' || typeof transport !== 'function') return false;
      this._development = true; // shared redeem flow (login return, receipt resume)
      this._production = true;
      this._previewTransport = transport;
      this._button.disabled = false;
      this._status.textContent = '';
      return true;
    }

    _confirmed(result) {
      return this._production ? confirmedProduction(result) : confirmedDevelopment(result);
    }

    enableDevelopment(transport) {
      if (!this.hasAttribute('data-development') || window.location.origin !== 'https://code-laxawess.myshopify.com' || typeof transport !== 'function') return false;
      this._development = true;
      this._previewTransport = transport;
      this._button.disabled = false;
      this._status.textContent = 'Test techniczny w sklepie deweloperskim. Nie dotyczy prawdziwych kart.';
      return true;
    }

    async resumeDevelopment(result, { revisit = false } = {}) {
      if (!this._development || this._locked) return;
      this._busy = false;
      this._form.removeAttribute('aria-busy');
      this._fields.disabled = false;
      this._fields.hidden = ['account_mismatch', 'authentication_required', 'identity_unavailable', 'processing_unknown', 'invalid_phone', 'order_not_eligible', 'limit_reached', 'already_redeemed'].includes(result?.state);
      if (this._confirmed(result)) {
        this._developmentResult = result;
        return this._showSuccess(result, { revisit });
      }
      this._status.textContent = messages[result?.state] ||
        'Nie udało się potwierdzić testowego odbioru. Zaloguj się adresem podanym w formularzu albo spróbuj ponownie.';
      this.dataset.state = result?.state === 'processing_unknown' ? 'pending' : 'error';
      this._locked = result?.state === 'processing_unknown';
      this._button.disabled = this._locked;
    }

    waitForDevelopmentVerification() {
      if (!this._development) return;
      // Explicit receipt recheck is permitted; resubmitting the form stays blocked while pending.
      this._locked = false;
      this._busy = true;
      this._fields.disabled = true;
      this._fields.hidden = true;
      this._form.setAttribute('aria-busy', 'true');
      this._status.textContent = 'Potwierdzamy konto i zapisane zgłoszenie…';
    }

    // Reveal only ever runs with a server-confirmed result. `revisit` = this browser already
    // showed this receipt (reload): show the open gift without replaying the celebration.
    async _showSuccess(response, { revisit = false } = {}) {
      const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mode = revisit ? 'static' : reduced ? 'reduced' : 'play';
      const format = value => new Intl.NumberFormat('pl-PL', { style: 'currency', currency: response.currency, minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(value);
      const total = Number(response.amount);
      const amount = format(total);
      const amountNode = this.querySelector('[data-amount]');
      const wait = ms => new Promise(resolve => window.setTimeout(resolve, ms));
      this.querySelector('.tb-prezent__account').href = response.accountPath;
      this.querySelector('[data-surprise]').textContent = revisit ? 'Prezent odebrany' : 'Niespodzianka!';
      if (revisit) this.querySelector('[data-result-help]').textContent = 'Ten kod został już wykorzystany. Środki są na Twoim koncie.';
      this._buildConfetti();
      this._fields.hidden = true;
      this._label.textContent = 'Otwieramy prezent…';
      this._status.textContent = revisit ? '' : 'Otwieramy prezent…';
      amountNode.textContent = mode === 'play' ? format(0) : amount;
      this.dataset.reveal = mode;
      this.dataset.state = 'opening';
      this.querySelector('.tb-prezent__result').hidden = false;
      // On phones the panel sits below the hero: bring the gift itself into view.
      this.querySelector('.tb-prezent__panel').scrollIntoView({ block: 'start', behavior: mode === 'play' ? 'smooth' : 'instant' });
      if (mode === 'play') {
        await wait(900);
        const start = performance.now();
        await new Promise(resolve => {
          const step = now => {
            const t = Math.min(1, (now - start) / 700);
            amountNode.textContent = t < 1 ? format(Math.round(total * (1 - Math.pow(1 - t, 3)))) : amount;
            if (t < 1) window.requestAnimationFrame(step); else resolve();
          };
          window.requestAnimationFrame(step);
        });
        await wait(80);
      } else if (mode === 'reduced') await wait(300);
      amountNode.textContent = amount;
      this.dataset.state = 'success';
      this._status.textContent = this._development && !this._production ? 'Test zakończony: ' + amount + ' dodano w sklepie deweloperskim.' : 'Niespodzianka! Masz ' + amount + ' na kolejne zakupy.';
      this._locked = true;
      this._busy = false;
      this._form.removeAttribute('aria-busy');
    }

    _buildConfetti() {
      const host = this.querySelector('[data-confetti]');
      if (!host || host.childElementCount) return;
      const colors = ['#25f4ee', '#fe2c55', '#ffd84d', '#ffffff', '#1990c6'];
      for (let i = 0; i < 22; i++) {
        const angle = (-160 + (140 / 21) * i) * Math.PI / 180;
        const distance = 95 + (i % 4) * 28;
        const piece = document.createElement('i');
        piece.style.setProperty('--x', Math.round(Math.cos(angle) * distance * 1.25) + 'px');
        piece.style.setProperty('--y', Math.round(Math.sin(angle) * distance + 150 + (i % 3) * 30) + 'px');
        piece.style.setProperty('--r', ((i % 2 ? 1 : -1) * (240 + i * 23)) + 'deg');
        piece.style.setProperty('--d', ((i % 5) * 0.03).toFixed(2) + 's');
        piece.style.setProperty('--c', colors[i % colors.length]);
        host.append(piece);
      }
    }

    async _submit() {
      if (this._busy || this._locked) return;
      if (!this._previewTransport) {
        this._status.textContent = messages.unavailable;
        return;
      }
      const fields = this._form.elements;
      const values = {
        given_name: fields.given_name.value.trim(), phone: fields.phone.value,
        email: fields.email.value.trim(), code: normalizeCode(fields.code.value),
        terms: fields.terms?.checked === true, marketing: fields.marketing.checked
      };
      fields.email.value = values.email;
      fields.code.value = values.code;
      const errors = validate(this._captureOnly ? { ...values, terms: true } : values, fields.email.validity.valid);
      for (const name of ['given_name', 'phone', 'email', 'code', 'terms']) {
        if (!fields[name]) continue;
        this.querySelector('[data-error="' + name + '"]').textContent = errors[name] || '';
        if (errors[name]) fields[name].setAttribute('aria-invalid', 'true');
        else fields[name].removeAttribute('aria-invalid');
      }
      const first = Object.keys(errors)[0];
      if (first) {
        this._status.textContent = 'Sprawdź zaznaczone pola.';
        fields[first].focus({ preventScroll: true });
        fields[first].scrollIntoView({ block: 'center', behavior: 'instant' });
        return;
      }
      this._busy = true;
      this.dataset.state = 'checking';
      this._fields.disabled = true;
      this._form.setAttribute('aria-busy', 'true');
      this._status.textContent = 'Sprawdzamy dane…';
      this._label.textContent = 'Sprawdzamy dane…';
      let response;
      try {
        response = await this._previewTransport({ ...values, phone: normalizePhone(values.phone) });
      } catch (_) {
        // Ambiguous failures never trigger an automatic retry or a reveal.
        response = { state: this._captureOnly ? 'error' : 'processing_unknown' };
      }
      if (this._captureOnly && response?.state === 'received' && /^[A-Za-z0-9_-]{43}$/.test(response.receipt || '')) {
        this.dataset.state = 'received';
        this._fields.hidden = true;
        this._status.textContent = 'Zgłoszenie zostało zapisane. Sprawdzimy je przed przyznaniem prezentu. Zachowaj kartę z kodem. Nie musisz ponownie wysyłać formularza.';
        this._busy = false;
        this._locked = true;
        this._form.removeAttribute('aria-busy');
        this._status.focus({ preventScroll: true });
        this._status.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        return;
      }
      if (this._captureOnly && response?.state === 'success') response = { state: 'error' };
      if (this._development && response?.state === 'native_login') {
        this._status.textContent = 'Zgłoszenie zapisane. Potwierdź swój e-mail w bezpiecznym logowaniu Shopify.';
        this._label.textContent = 'Przejdź do logowania';
        this._busy = false;
        this._fields.disabled = false;
        this._form.removeAttribute('aria-busy');
        return;
      }
      if (response && response.state === 'success') {
        if (!(this._development ? this._confirmed(response) : confirmedPreview(response))) response = { state: 'processing_unknown' };
        else {
          await this._showSuccess(response);
        }
      }
      if (!this._locked) {
        const state = response && Object.hasOwn(messages, response.state) ? response.state : 'error';
        this.dataset.state = state === 'processing_unknown' ? 'pending' : 'error';
        this._status.textContent = this._captureOnly && state === 'error'
          ? 'Nie udało się teraz zapisać zgłoszenia. Spróbuj ponownie za chwilę.' : messages[state];
        this._locked = state === 'processing_unknown';
        this._fields.disabled = this._locked;
        this._label.textContent = this._captureOnly ? 'Zgłaszam odbiór' : 'Odbieram prezent';
        if (state === 'invalid_phone') {
          // The form is still filled in: point at the one field Shopify refused.
          const phone = this._form.elements.phone;
          this.querySelector('[data-error="phone"]').textContent = 'Shopify nie przyjął tego numeru. Sprawdź go i kliknij ponownie.';
          phone.setAttribute('aria-invalid', 'true');
          this._busy = false; this._form.removeAttribute('aria-busy'); this._button.disabled = false;
          phone.focus({ preventScroll: true });
          phone.scrollIntoView({ block: 'center', behavior: 'instant' });
          return;
        }
      }
      this._busy = false;
      this._form.removeAttribute('aria-busy');
      this._button.disabled = this._locked;
      this._status.focus({ preventScroll: true });
      this._status.scrollIntoView({ block: 'nearest', behavior: 'instant' });
    }
  }
  customElements.define('ten-but-prezent', TenButPrezent);
}());
